import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { publish } from '../Layout/GlobalEvents';
import { SubMenuEvents} from '../../global/PubSubTokens';
import { Image, Menu, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import StatusPill from '../Utils/StatusPill';
import {useNavigate } from 'react-router-dom';

const PatientMenu = (props) => {
    const navigate = useNavigate()
    const [menuItems, setMenuItems] = React.useState([]);
    const { submenu } = useAuth();

    useEffect(() => {
       const sm = submenu.map((item, index) =>
           (
               !item.isDivider ? {
                   key: index,
                   label: <div className="d-flex align-items-center gap-2 px-2">
                       {item.title}
                       {
                           item.showStatus && (
                           <StatusPill
                               style={{ height: '20px' }}
                               className={item.status ? 'allergy-complete d-flex align-items-center' : 'allergy-pending d-flex align-items-center'}
                               title={item.status ? 'complete' : 'incomplete'}
                           /> )
                       }
                   </div>,
                   icon:<Image preview={false} src={item.iconSource} />,
                   onClick:() =>{
                      if(item.link !== undefined || item.link !== '#')  navigate(item.link);
                       publish(SubMenuEvents, {
                           type: item.eventType,
                           payload: item.eventPayload,
                       })
                   }

               }: {
                   key: index,
                   type: 'group',
                   label: <div className="d-flex align-items-center gap-2">
                       {item.mainText}
                       {
                           item.withTooltip &&
                           <Tooltip placement="right" color="#ffffff"
                                    title={
                                        <span className='side-item-link-color tt-fs'>
                                        {item.toolTipText}
                                            <span className="text-decoration-underline cursor-pointer" onClick={()=> {
                                                publish(SubMenuEvents, {
                                                    type: item.eventType,
                                                    payload: item.eventPayload,
                                                })
                                            }}>
                                            {item.toolTipTextUnderline}
                                        </span>
                                    </span>
                                    }>
                               <InfoCircleOutlined  />
                           </Tooltip>
                       }
                   </div>
               }
           ));
       if(Array.isArray(submenu) && submenu.length > 0)  setMenuItems([{key:'1sub', label:'Diagnosis and Allergies', type: 'group' },...sm]);
    }, [submenu]);
    return (
        <div className="d-flex flex-column gap-3 pt-5">
            {
                Array.isArray(menuItems) &&
                <Menu className="main-side-menu main-menu-icons"
                    mode="inline"
                    items={menuItems}
                />
            }
        </div>
    );
};

export default PatientMenu;
